import { FC, ChangeEvent } from "react";
import {
  Box,
  TextField,
  Typography,
  FormHelperText,
  Paper,
} from "@mui/material";

interface TimePickerProps {
  value: string; // formato HH:MM
  onChange: (value: string) => void;
  disabled?: boolean;
}

const TimePicker: FC<TimePickerProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Validar formato HH:MM
    if (/^\d{2}:\d{2}$/.test(inputValue) || inputValue === "") {
      onChange(inputValue);
    }
  };

  return (
    <Paper variant="outlined" className="p-3">
      <Box>
        <Typography variant="subtitle1" className="mb-2">
          Selecione o horário preferido para receber notificações
        </Typography>

        <TextField
          type="time"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          inputProps={{
            step: 300, // 5 minutos
          }}
          fullWidth
          variant="outlined"
          size="small"
          sx={{ width: "150px" }}
        />

        <FormHelperText className="mt-2">
          Formato: HH:MM (24 horas)
        </FormHelperText>
      </Box>
    </Paper>
  );
};

export default TimePicker;
